"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

var _constants = require("./constants");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Tabs = _interopRequireWildcard(require("../Tabs"));

var _Title = _interopRequireDefault(require("../Title"));

var _Button = _interopRequireDefault(require("../Button"));

var _Paragraph = _interopRequireDefault(require("../Paragraph"));

var _DatePicker = _interopRequireDefault(require("../DatePicker"));

var _propTypes2 = require("../DatePicker/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HeaderPanel = function HeaderPanel(props) {
  var view = props.view,
      date = props.date,
      views = props.views,
      labels = props.labels,
      locale = props.locale,
      onChange = props.onChange,
      localizer = props.localizer,
      onNavigate = props.onNavigate,
      setActiveDate = props.setActiveDate,
      fullDayFormat = props.fullDayFormat,
      fullMonthFormat = props.fullMonthFormat,
      weekdaysShortFormat = props.weekdaysShortFormat,
      datePickerLabels = props.datePickerLabels;
  var title = (0, _react.useMemo)(function () {
    return (0, _utils.localizeFormat)(localizer, date, view === 'day' ? fullDayFormat : fullMonthFormat);
  }, [date, view, fullDayFormat, fullMonthFormat]);

  var onTabClick = function onTabClick(key) {
    onChange(key.replace('calendar-tab-', ''));
  };

  var onPrevClick = function onPrevClick() {
    onNavigate(_constants.navigate.PREVIOUS);
  };

  var onNextClick = function onNextClick() {
    onNavigate(_constants.navigate.NEXT);
  };

  var onTodayClick = function onTodayClick() {
    var now = new Date();
    date.setMonth(now.getMonth());
    date.setYear(now.getFullYear());
    setActiveDate(now);
    onNavigate(_constants.navigate.TODAY);
  };

  var onDateClick = function onDateClick(dateCalendar) {
    date.setDate(dateCalendar.date());
    date.setMonth(dateCalendar.month());
    date.setYear(dateCalendar.year());
    setActiveDate(date);
    onNavigate(_constants.navigate.DATE, date);
  };

  var extraContent = /*#__PURE__*/_react.default.createElement(_Tabs.TabsExtraItem, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "tab-current"
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
    dropdownClassName: "calendar-picker",
    onChange: onDateClick,
    locale: locale,
    labels: datePickerLabels
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "button_icon arrow_left",
    onClick: onPrevClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "arrow-left",
    size: 10
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "secondary",
    size: "small",
    onClick: onTodayClick
  }, labels.today), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "button_icon arrow_right",
    onClick: onNextClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "arrow-right",
    size: 10
  }))));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-header-panel"
  }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    activeKey: "calendar-tab-".concat(view),
    tabBarExtraContent: extraContent,
    onTabClick: onTabClick
  }, views.map(function (view) {
    return /*#__PURE__*/_react.default.createElement(_Tabs.TabPane, {
      tab: labels[view],
      index: view,
      key: "calendar-tab-".concat(view)
    });
  })), /*#__PURE__*/_react.default.createElement(_Title.default, {
    type: 3
  }, title, view === 'day' ? ', ' : ' ', date.getFullYear()), view === 'day' && /*#__PURE__*/_react.default.createElement(_Paragraph.default, null, (0, _utils.localizeFormat)(localizer, date, weekdaysShortFormat)));
};

HeaderPanel.propTypes = {
  view: _propTypes.default.string.isRequired,
  date: _propTypes.default.instanceOf(Date).isRequired,
  views: _propTypes.default.arrayOf(_propTypes.default.oneOf('month', 'week', 'day')).isRequired,
  labels: _propTypes.default.shape({
    day: _propTypes.default.string,
    week: _propTypes.default.string,
    month: _propTypes.default.string,
    today: _propTypes.default.string
  }).isRequired,
  onChange: _propTypes.default.func.isRequired,
  setActiveDate: _propTypes.default.func.isRequired,
  localizer: _propTypes.default.shape({
    format: _propTypes.default.func
  }).isRequired,
  fullDayFormat: _propTypes.default.string.isRequired,
  fullMonthFormat: _propTypes.default.string.isRequired,
  datePickerLabels: _propTypes2.datePickerLocalePropTypes,
  weekdaysShortFormat: _propTypes.default.string.isRequired,
  onNavigate: _propTypes.default.func.isRequired
};
HeaderPanel.defaultProps = {
  datePickerLabels: undefined
};
var _default = HeaderPanel;
exports.default = _default;